import question from './question';

export default {
  question_list: {
    values: [ question ],
    original: question,
    error: null,
    name: 'question_list',
    placeholder: 'Question',
    breed: 'array',
    touched: true,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  }
}



/** WEBPACK FOOTER **
 ** ./src/forms/survey/createPhase3.js
 **/